import './App.css';
import Hero from './components/Hero/Hero';
import Programs from './components/Programs/Programs';
import Reason from './components/Reasons/Reason';
import Plan from './components/Plan/Plan';
import Testimonials from './components/Testimonials/Testimonials';
import Join from './components/Join/Join';
import Footer from './components/Footer/Footer';
function App() {
  return (
    <div className="App">
        <Hero />
        <Programs/>
        <Reason/>
        <Plan/>
        <Testimonials/>
        <Join/>
        <Footer/>
    </div>
  );
}

export default App;
